module.exports = __webpack_public_path__ + "media/images/emblems/Avry-coat_of_arms-186a2143a5b0f72e164f277be0725f10.svg";